import { SET_PENDING_APPROVALS_COUNT } from '../actions/approvalActions';

const initState = {
  pendingCount: 0,
};

export default (state = initState, action) => {
  switch (action.type) {
    case SET_PENDING_APPROVALS_COUNT:
      return { ...state, pendingCount: action.count };

    default:
      return state;
  }
};
